import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, LOGO_URL } from "@/lib/api";
import { Lock, Mail, Loader2, ShieldCheck, AlertCircle } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("admin@atfftrade.africa");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("atff_admin_token", data.token);
      localStorage.setItem("atff_admin_email", data.email);
      navigate("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 atff-hero-bg">
      <div className="absolute inset-0 atff-grid-mask pointer-events-none" />
      <form onSubmit={submit} className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl p-8" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-6">
          <img src={LOGO_URL} alt="ATFF" className="h-12 w-12 object-contain" />
          <div>
            <p className="display font-bold text-[#0C1F4A]">ATFF Admin</p>
            <p className="text-[11px] text-[#E96C0F] tracking-wider uppercase">Waitlist Dashboard</p>
          </div>
        </div>
        <h1 className="display text-2xl font-extrabold text-[#0C1F4A]">Sign in</h1>
        <p className="text-sm text-slate-600 mt-1">Manage ADTF 2026 waitlist submissions.</p>

        <div className="mt-6 space-y-4">
          <label className="block">
            <span className="field-label">Email</span>
            <div className="relative mt-1">
              <Mail className="absolute left-3 top-3 text-slate-400" size={16} />
              <input data-testid="admin-email-input" type="email" required
                value={email} onChange={(e) => setEmail(e.target.value)}
                className="input-base pl-9" placeholder="admin@atfftrade.africa" />
            </div>
          </label>
          <label className="block">
            <span className="field-label">Password</span>
            <div className="relative mt-1">
              <Lock className="absolute left-3 top-3 text-slate-400" size={16} />
              <input data-testid="admin-password-input" type="password" required
                value={password} onChange={(e) => setPassword(e.target.value)}
                className="input-base pl-9" placeholder="••••••••" />
            </div>
          </label>
          {err && (
            <div className="flex items-start gap-2 text-sm text-[#B91C1C] bg-[#FEF2F2] border border-[#FECACA] rounded-lg p-3">
              <AlertCircle size={16} className="mt-0.5 shrink-0" /> <span data-testid="login-error">{err}</span>
            </div>
          )}
          <button data-testid="admin-login-submit" disabled={busy}
            className="btn-orange w-full inline-flex items-center justify-center gap-2 py-3 rounded-full font-bold disabled:opacity-70">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <ShieldCheck size={16} />}
            {busy ? "Signing in..." : "Sign in to dashboard"}
          </button>
        </div>
      </form>
    </div>
  );
}
